export const Props = () => ({
  //Активный таймкод?
  isActive: { type: Boolean },

  //Текст таймкода
  text: { type: String },

  //Время таймкода
  time: { type: String }
});